import { doForgotSubdomain as doForgotSubdomainAction } from 'actions/account'

export function doForgotSubdomain(params) {
  return doForgotSubdomainAction(params.emailInput)
}
